module.exports = __webpack_public_path__ + "img/1.4538dfd3.jpg";